var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetourIcon = function SvgDetourIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8BCFEA",
    d: "M14.824 2.667A4.9 4.9 0 0 0 12.802.703Q11.487 0 9.73 0H6.064v1.597H9.73q1.857 0 2.86 1.078t1.002 2.914-1.002 2.914q-1.003 1.079-2.86 1.078H6.064v1.597H9.73q1.759 0 3.073-.703a4.9 4.9 0 0 0 2.022-1.972q.705-1.269.706-2.914c0-1.096-.235-2.081-.706-2.922"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#38ACDD",
    d: "M1.176 13.333a4.9 4.9 0 0 0 2.022 1.964Q4.513 16 6.27 16h3.665v-1.597H6.27q-1.857 0-2.86-1.078-1.003-1.077-1.002-2.914 0-1.836 1.002-2.914t2.86-1.078h3.665V4.822H6.27q-1.759 0-3.073.703a4.9 4.9 0 0 0-2.022 1.972Q.471 8.766.47 10.41c0 1.096.235 2.081.706 2.922"
  })));
};
export default SvgDetourIcon;